import { EntityBase } from './EntityBase';
import { ClusterGroup } from './ClusterGroup';
import { ClusterPart } from './ClusterPart';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class ClusterPath extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   clusterPathId: number;
   clusterPathName: string;
   clusterGroupId: number;
   notes: string;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   clusterGroup: ClusterGroup;
   clusterParts: ClusterPart[];
}

